import { FC } from 'react'
import { Tooltip } from 'src/@legacy/@core/components/share/ANTD'
import { translateRouterHref } from 'src/@legacy/@core/components/share/AppLink'
import { useTranslation } from 'src/@legacy/@core/hooks/UserTranslation'
import EmptyData from 'src/@legacy/components/EmptyData'

export type ResourceType = { title: string; link: string; link_vi: string; id: number }

const ResourceList: FC<{ groupData: { [key_title: string]: ResourceType[] } }> = ({ groupData }) => {
  const { translate, currentLanguage } = useTranslation()

  return (
    <>
      <style jsx>{`
        .resource-result {
          margin-top: 64px;
        }
        .resource-result__title {
          font-size: 28px;
          line-height: 36px;
          color: #141921;
          font-weight: bold;
          padding-bottom: 23px;
          border-bottom: 1px solid #e8e8e8;
          margin-bottom: 8px;
        }
        .grid-contain {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 0 56px;
          margin-right: 32px;
        }
        .resource-result__item {
          margin-top: 16px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          font-size: 16px;
          line-height: 24px;
        }
        .resource-result__item a {
          color: var(--primary);
        }

        .resource-wrapper .empty-wrapper {
          padding-top: 64px;
          padding-bottom: 0;
        }

        @media only screen and (max-width: 576px) {
          .resource-result {
            margin-top: 40px;
            margin-bottom: 8px;
          }
          .grid-contain {
            display: block;
          }
          .resource-result__title {
            font-size: 18px;
            line-height: 24px;
            padding-bottom: 15px;
            margin-bottom: 0;
          }
          .resource-result__item {
            margin-top: 16px;
            margin-bottom: 4px;
          }
          .resource-result__item a {
            color: var(--primary);
          }
        }
      `}</style>
      {Object.values(groupData).find((glossaryList) => glossaryList.length > 0) ? (
        Object.keys(groupData).map((key_title) =>
          groupData[key_title].length > 0 ? (
            <div id={`resource-${key_title.replace(/\s/g, '-')}`} key={`resource-${key_title}`} className={`resource-result`}>
              <h2 className="resource-result__title">{key_title}</h2>
              <div className="grid-contain">
                {groupData[key_title].map((item) => (
                  <div key={`resource-${key_title}-${item.id}`} className="resource-result__item">
                    <Tooltip title={item.title}>
                      <a href={translateRouterHref(currentLanguage === 'en' ? item.link : item.link_vi, currentLanguage)} rel="noreferrer">
                        {item.title}
                      </a>
                    </Tooltip>
                  </div>
                ))}
              </div>
            </div>
          ) : null
        )
      ) : (
        <EmptyData title={translate('empty:no_job_found')} message={translate('empty:no_result_that_match_your_search')} />
      )}
    </>
  )
}

export default ResourceList
